import noteMapping from "./integuru_note_mapping.json";

/**
 * Get the note template name and fields for a given org, patient_type, and provider.
 * Falls back to patient_type: null if no exact match is found.
 * Also supports phrase-based matching if patient_type is not a direct match.
 * @param {string} org - The org name (e.g., 'ironwood medonc')
 * @param {string} patient_type - The patient type (e.g., 'new', 'telemed', 'fu')
 * @param {string} providerName - Optional provider name for provider-specific templates
 * @param {Object} patient - Optional patient object with additional data
 * @returns {Object} Object with template and note_field properties, or null if not found
 */
// Added providerName param for special Michael Byrne logic
export function getNoteTemplateForOrg(
  org,
  patient_type,
  providerName,
  patient = {}
) {
  // Use patient.type as a fallback if available
  const type = patient.type || patient_type;
  
  console.log(`Finding template for org: ${org}, patient_type: ${type}, provider: ${providerName || 'none'}`);

  if (!noteMapping.org || !Array.isArray(noteMapping.org)) return null;

  // Find the org object
  const orgObj = noteMapping.org.find((o) => o.org === org);
  if (!orgObj) return null;

  // First try to find a match with org, patient_type, and provider
  if (providerName) {
    // Try to find an exact match with all three parameters
    let ptObj = orgObj.patient_type_phrases.find(
      (pt) =>
        pt.patient_type === type &&
        pt.provider &&
        // Check if provider is an array or a string
        ((Array.isArray(pt.provider) && pt.provider.includes(providerName)) ||
          pt.provider === providerName)
    );

    if (ptObj) {
      console.log(`Provider match found: ${providerName}, patient_type: ${type}, using template: ${ptObj.template}`);
      if (ptObj.note_field) {
        console.log(`Note fields: ${ptObj.note_field.join(', ')}`);
      }
      return {
        template: ptObj.template,
        note_field: ptObj.note_field || []
      };
    }
  }

  // If no provider-specific match was found, try just org and patient_type
  let ptObj = orgObj.patient_type_phrases.find(
    (pt) =>
      pt.patient_type === type &&
      (!pt.provider || (Array.isArray(pt.provider) && pt.provider.length === 0))
  );

  // If not found, try phrase-based matching (if patient_type is a phrase)
  if (!ptObj && type) {
    ptObj = orgObj.patient_type_phrases.find(
      (pt) =>
        Array.isArray(pt.phrases) &&
        pt.phrases.includes(type.toLowerCase()) &&
        (!pt.provider ||
          (Array.isArray(pt.provider) && pt.provider.length === 0))
    );
  }

  // If still not found, try fallback to patient_type: null
  if (!ptObj) {
    ptObj = orgObj.patient_type_phrases.find(
      (pt) =>
        pt.patient_type === null &&
        (!pt.provider ||
          (Array.isArray(pt.provider) && pt.provider.length === 0))
    );
  }

  if (ptObj) {
    console.log(`Template found: ${ptObj.template} for patient_type: ${type}`);
    if (ptObj.note_field) {
      console.log(`Note fields: ${ptObj.note_field.join(', ')}`);
    }
    return {
      template: ptObj.template,
      note_field: ptObj.note_field || []
    };
  }
  
  console.log(`No template found for org: ${org}, patient_type: ${type}`);
  return null;
}
